import { Rocket } from "lucide-react";

/**
 * Sticky mobile CTA — visible on mobile only. Smooth-scrolls to the pricing
 * section rather than navigating away, per Phase-1 UX brief.
 */
export default function StickyCta() {
  const onClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const el = document.getElementById("pricing");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <a
      href="#pricing"
      onClick={onClick}
      data-testid="wc-sticky-cta"
      className="md:hidden fixed bottom-4 left-4 right-4 z-40 bg-[#d3fc3a] text-[#1a1a24] font-display font-semibold text-sm rounded-full px-4 py-3.5 shadow-2xl flex items-center justify-center gap-2 active:scale-[0.98] transition-transform"
    >
      <Rocket size={16} /> Yes, Help Me Build My $10K/Month Business
    </a>
  );
}
